import React from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import logo from '../../../assets/site/ds360-logo.png';
import HomeSectionLink from '../components/HomeSectionLink';
import Icon from '../components/Icon';
import { contact } from '../data/contact';
import cx from '../utils/cx';
import ui from '../styles/primitives.module.css';
import NavDropdown from './NavDropdown';
import UserMenu from './UserMenu';
import styles from './Navbar.module.css';

const Navbar = () => {
  const { currentUser } = useAuth();
  const { pathname } = useLocation();

  return (
    <header className={styles.header}>
      <div className={styles.bar}>
        <HomeSectionLink hash="#top" className={styles.brand}>
          <img src={logo} alt="DS360 Investment — Building Wealth Rebuilding Cities" />
        </HomeSectionLink>

        <nav aria-label="Primary" className={styles.nav}>
          <ul className={styles.links}>
            <li>
              <HomeSectionLink
                hash="#top"
                className={styles.navLink}
                aria-current={pathname === '/' ? 'page' : undefined}
              >
                <Icon name="home" className={styles.icon} />
                Home
              </HomeSectionLink>
            </li>
            <li>
              <NavLink className={styles.navLink} to="/about" end>
                <Icon name="info" className={styles.icon} />
                About
              </NavLink>
            </li>
            <li>
              <HomeSectionLink hash="#insights" className={styles.navLink}>
                <Icon name="book" className={styles.icon} />
                Resources
              </HomeSectionLink>
            </li>
            <li>
              <NavDropdown
                label={
                  <>
                    <Icon name="id" className={styles.icon} />
                    Contact
                    <Icon name="chevron" className={styles.chevron} />
                  </>
                }
              >
                <li>
                  <a className={styles.menuItem} href={contact.phoneHref}>
                    {contact.phoneDisplay}
                  </a>
                </li>
                <li>
                  <a className={styles.menuItem} href={contact.emailHref}>
                    Email us
                  </a>
                </li>
                <li>
                  {/* every site page ends with the shared ScheduleCall section (#call) */}
                  <a className={styles.menuItem} href="#call">
                    Schedule a call
                  </a>
                </li>
              </NavDropdown>
            </li>
          </ul>
        </nav>

        <div className={styles.auth}>
          {currentUser ? (
            <UserMenu user={currentUser} />
          ) : (
            <>
              <Link className={cx(ui.btn, ui.btnOutline, styles.authBtn)} to="/login">
                Login
              </Link>
              <Link className={cx(ui.btn, ui.btnDark, styles.authBtn)} to="/signup">
                Sign Up
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Navbar;
